import { Button, Dropdown } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import setLoading from '@/redux/actions/loadingAction';
import { useTranslations } from '@/translations/useTranslations.js';

const items = [
    { label: 'item 1', key: 'item-1' }, // remember to pass the key prop
    { label: 'item 2', key: 'item-2' },
];

const Dashboard = () => {
    const { t } = useTranslations();
    const dispatch = useDispatch();
    const nav = useNavigate();
    const goPage = () => {
        nav('mt');
    };

    useEffect(() => {
        console.log('THIS IS VITE ENV', import.meta.env);
    }, []);

    const setLoad = () => {
        dispatch(setLoading(true, 'loading_test'));
        setTimeout(() => {
            dispatch(setLoading(false, ''));
        }, 1000);
    };

    return (
        <>
            {t('label.login')}
            <h1>Dashboard</h1>
            <h1>PAGE PAGE PAGE</h1>
            <h1>PAGE PAGE PAGE</h1>
            <h1>PAGE PAGE PAGE</h1>
            <div className="center-item">aa</div>
            <Button onClick={setLoad}>set loading</Button>
            <Button onClick={goPage}>go metamask test</Button>
            <hr />
            <Dropdown menu={{ items }}>
                <a>Hover me</a>
            </Dropdown>
            {}
        </>
    );
};

export default Dashboard;
